import { type ReactNode } from "react";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { IconSize } from "~/common/components/icon/IconSize";
import classNames from "classnames";
import LinearInfo from "~/features/configurator/Linear/components/LinearInfo";
import LanguageAwareExternalContent from "~/features/configurator/Linear/components/LanguageAwareExternalContent";
import { useConfiguratorType } from "~/features/configurator/common/useConfiguratorType";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import { Alert } from "~/common/mui/Alert/Alert";

interface Props {
  className?: string;
  title: string;
  csticIndex: number;
  csticAmount: number;
  children: ReactNode;
  info?: string;
  description?: string;
  isPicked: boolean;
  showError?: boolean;
  errorMessage: string;
}

const SubstepFrame = (props: Props) => {
  const { className, title, description, csticAmount, csticIndex, isPicked, showError, errorMessage, info } = props;

  const configuratorType = useConfiguratorType();
  const isOldConfigurator = configuratorType === ConfiguratorType.System;

  const externalContentCls = isOldConfigurator
    ? "scha__lc__external-content--shaft"
    : "scha__lc__external-content--shaft";

  return (
    <div className={classNames(className, "scha__linear-configurator__semi-steps__frame", isPicked && "picked")}>
      <div className="scha__linear-configurator__semi-steps__frame__count">
        <Icon className={"image-scale-up"} type={IconType.Check} size={IconSize.FONT_20} />
        <span className={"ml-2"}>
          {csticIndex}/{csticAmount}
        </span>
      </div>
      <h3 className="scha__linear-configurator__semi-steps__frame__title">
        <LanguageAwareExternalContent content={title} className={"scha__lc__external-label"} />
        <LinearInfo info={info} popupClassName={externalContentCls} />
      </h3>
      {description && (
        <div className="mt-3">
          <LanguageAwareExternalContent content={description} className={"scha__lc__external-label"} />
        </div>
      )}
      {showError && (
        <Alert className={"mt-30"} severity="error" data-message="error">
          {errorMessage}
        </Alert>
      )}
      <div className="mt-30 scha__linear-configurator__semi-steps__frame__tile">{props.children}</div>
    </div>
  );
};

export default SubstepFrame;
